import { render, staticRenderFns } from "./CustomReportPage.vue?vue&type=template&id=45b313ed&"
import script from "./CustomReportPage.vue?vue&type=script&lang=js&"
export * from "./CustomReportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports